module.exports = __webpack_public_path__ + "static/img/ABUIABACGAAgp77xkQYo0IWe7AIwwAI48AE.3cdb7b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABACGAAgp77xkQYo0IWe7AIwwAI48AE.jpg
// module id = 9TS3
// module chunks = 1